/**
 * Google Tag Manager App Ids for different regions.
 */
export const GTM_IDS = {
    de_or_at: 'GTM-MHPPLK',
    non_de_or_at: 'GTM-W4MX7B',
    usa: 'GTM-NWZX78L',
};
//# sourceMappingURL=googleAnalytics.js.map